import { MaterialResponse } from '../Types/MaterialResponse';
import { IMaterialReducer } from '../Interfaces/IMaterialReducer';
import PASS_STATUS from '../../../__core/Enums/PassStatus';
import { SideMenuResponse } from '../Types/SideMenuResponse';
import MATERIAL_ACCESS from '../../../__core/Enums/MaterialAccess';

export const currentMaterialInitState: MaterialResponse = {
  data: {
    id: '',
    name: '',
    sourceName: '',
    type: '',
    tags: [],
    result: null,
    status: PASS_STATUS.NOT_VISITED,
    progress: { done: 0, all: 0 },
    content: {
      externalUrl: '',
      githubUrl: '',
      html: '',
    },
    review: null,
    access: MATERIAL_ACCESS.ALL,
  },
  metadata: {
    navigation: {
      contentLevel: '',
      nextChapterId: '',
      nextMaterialId: '',
      nextSlug: '',
      previousChapterId: '',
      previousMaterialId: '',
      previousSlug: '',
    },
  },
};

export const menuInitState: SideMenuResponse = {
  data: {
    id: '',
    name: '',
    number: 0,
    chapters: [],
    progress: { done: 0, all: 0 },
  },
  metadata: {},
};

export const materialReducerInitState: IMaterialReducer = {
  currentMaterial: currentMaterialInitState,
  menu: menuInitState,
  fetchMaterialInProgress: false,
  fetchMenuInProgress: false,
  currentMaterialBase64: { data: '', metadata: {} },
};
